import React from "react";
import { Box, Typography } from "@mui/material";

const CompanyInfo = ({ company }) => {
  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        p: 2,
        maxHeight: 250,
        minWidth: "80%",
        overflow: "hidden",
        borderRadius: 1,
      }}
    >
      <Typography
        sx={{
          fontWeight: "bold",
          color: "primary.main",
          mb: 1,
          fontSize: 14,
        }}
      >
        Bill From
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 0.5,
          "& > :last-child": { ml: 1.5 },
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            color: "text.secondary",
            mr: 1,
            fontSize: 12,
            minWidth: 80,
          }}
        >
          Email
        </Typography>
        <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
          {company?.email}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 0.5,
          "& > :last-child": { ml: 1.5 },
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            color: "text.secondary",
            mr: 1,
            fontSize: 12,
            minWidth: 80,
          }}
        >
          Phone
        </Typography>
        <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
          {company?.phoneNo}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 0.5,
          "& > :last-child": { ml: 1.5 },
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            color: "text.secondary",
            mr: 1,
            fontSize: 12,
            minWidth: 80,
          }}
        >
          Address
        </Typography>
        <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
          {company?.address}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 0.5,
          "& > :last-child": { ml: 1.5 },
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            color: "text.secondary",
            mr: 1,
            fontSize: 12,
            minWidth: 80,
          }}
        >
          Organization
        </Typography>
        <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
          {company?.organization_name}
        </Typography>
      </Box>
    </Box>
  );
};

export default CompanyInfo;
